export default "__VITE_ASSET__0c962d6d__"